var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.noContent
      ? _c("div", [_c("span", { staticClass: "pl-2" }, [_vm._v("0")])])
      : _vm._e(),
    _c(
      "div",
      [
        _vm._l(_vm.itemsToRender, function (item) {
          return _c(
            "div",
            {
              key: item.name,
              staticClass:
                "border border-primary-500 rounded-full px-2 py-0.5 text-gray-800 bg-white inline-block tag-margin m-1 max-w-full",
              attrs: { title: item },
            },
            [
              _vm.clickable
                ? [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: _vm.path,
                            params: { id: item.id },
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex text-sm cursor-pointer" },
                          [
                            _c("span", { staticClass: "truncate" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                : [
                    _c("div", { staticClass: "flex text-sm" }, [
                      _c("span", { staticClass: "truncate" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                    ]),
                  ],
            ],
            2
          )
        }),
        _vm.itemsMoreThanLimit
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "border border-primary-500 rounded-full px-2 py-0.5 text-gray-800 bg-white inline-block tag-margin m-1 max-w-full cursor-pointer",
                },
                [
                  _c("div", { staticClass: "flex text-sm" }, [
                    _c("span", { staticClass: "truncate" }, [
                      _vm._v(_vm._s(_vm.items.length - _vm.limit) + " more"),
                    ]),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }